import styled from 'styled-components';

export const Container = styled.div`
  height: calc(100vh - 115px);
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
